import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "triggerButton"];
import { View } from 'foundations-components/components/View';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import styled from 'foundations-theming/utils';
import { AIShimmer } from '../loading/AILoadingShimmer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "AITextArea__StyledDiv"
})(["position:relative;textarea{", ";}"], ({
  isLoading,
  theme
}) => isLoading && `color: ${theme.color['text-core-default']} !important;`);
export const AITextArea = _ref => {
  let {
      loading = false,
      triggerButton
    } = _ref,
    aiTextAreaProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AIShimmer, {
    isLoading: loading,
    paddingRight: 36,
    paddingLeft: 12,
    paddingTop: 6,
    marginRight: 2,
    marginLeft: 2,
    marginBottom: 2,
    marginTop: 2,
    children: /*#__PURE__*/_jsxs(StyledDiv, {
      isLoading: loading,
      children: [/*#__PURE__*/_jsx(View, {
        zIndex: 1,
        position: "absolute",
        insetBlockEnd: "100",
        insetInlineEnd: "400",
        backgroundColor: "fill-field-default",
        children: triggerButton
      }), /*#__PURE__*/_jsx(TextArea, Object.assign({}, aiTextAreaProps, {
        placeholder: loading ? '' : aiTextAreaProps.placeholder,
        value: loading ? '' : aiTextAreaProps.value,
        defaultValue: loading ? '' : aiTextAreaProps.defaultValue
        // Disable resize when loading - will break the AI Shimmer
        ,
        resize: loading ? false : 'vertical'
      }))]
    })
  });
};
AITextArea.displayName = 'AITextArea';